<template>
  <div class="searchContent schMd">
    <el-row class="cardTitle">
      <div class="insideBox gbInsideBox">
        <div class="slot">
          <slot />
        </div>

        <div class="setCheckBox gbBatchUnlock" v-if="batchActionShow && list.tableData.length">
          <span class="choiceNum" v-if="selectNum>0">已勾选{{selectNum}}个</span>
          <el-button :loading="actionLoading" type="info" plain size="small" v-interestExpire @click="batchUnlockFn">批量解锁</el-button>
          <slot name="beforeBatch"></slot>
          <el-button :loading="actionLoading1" v-if="batchStarShow" type="info" plain size="small" @click="batchStarFn">收藏</el-button>
        </div>
      </div>
      <div class="btnBlock" v-if="batchActionShow && list.tableData.length">
        <el-checkbox v-if="[1,2,4,5,10,11].includes(companyType)" v-model="isUnlock" label="过滤已解锁" @change="isUnlockChange" :class="isUnlock?'filter-unlock':''"></el-checkbox>
        <slot name="two"></slot>
      </div>
    </el-row>
    <div class="clueList" v-if="shortVideoType !== '1'">
      <div class="companyCardList">
        <div class="companyHead">
          <div class="compHDLeft">
            <el-checkbox style="margin-right:50px" :indeterminate="isIndeterminate" v-model="checkAll" @change="selectAllFnG"></el-checkbox>
            <span class="headTitle headInfo">企业信息</span>
          </div>
          <span :class="['headTitle','headMay',companyType == 5?'mapHead':'']">联系方式</span>
        </div>
        <company-card :searchType="searchType" @reset-unlock="resetUnlock" @click-list="clickListA" :companyType="companyType" :subscriptionType="subscriptionType" class="companyCard"
          v-for="(item,index) in list.tableData" @unlock-change="handleUnlockChange(index)" @getStar="getStar(index)" :key="numKey+index" :xiaoT="true" :baseData="item">
          <el-checkbox class="checkBoxes" v-if="checkBoxShow && list.tableData.length>0" v-model="checkList[index].checked" @click.native.stop="" @change="selectSingleFnG"></el-checkbox>
        </company-card>
        <div class="emptyBox" v-if="!list.tableData.length">
          <div class="emptyBox-box">
            <div class="empty-ordinary">
              <img src="@/assets/newicons/i002.png" alt="" srcset="">
              <p class="center">暂无数据</p>
            </div>
            <!-- 隐藏 深度挖掘 -->
            <!-- <div class="empty-deep" v-if="isEnterpriseName">
              <p>抱歉，未找到相关企业</p>
              <p>1.输入更准确的企业名称，重新搜索</p>
              <p>2.试试深度挖掘，进行精准查询</p>
            </div> -->
          </div>
          <!-- <el-button type="primary" v-if="isEnterpriseName" @click="clickDeepAction" :loading="deepLoading">深度挖掘</el-button> -->
        </div>
      </div>
    </div>
    <div class="clueList" v-if="shortVideoType === '1'">
      <div class="companyCardList">
        <companyList :inquiryData="inquiryData" @immediatelyUnlock="immediatelyUnlock" @checkDetails="checkDetails" @unHandleCollect="unHandleCollect" @handleCollect="handleCollect"
          class="companyCard" v-for="(item,index) in list.tableData" :shortVideoType="shortVideoType" :key="index" :xiaoT="true" :baseData="item">
          <el-checkbox class="checkBoxes" v-if="checkBoxShow" v-model="checkList[index].checked" @click.native.stop=""></el-checkbox>
        </companyList>
        <div class="emptyBox" v-if="!list.tableData.length">
          <div class="emptyBox-box">
            <div class="empty-ordinary">
              <img src="@/assets/emptyBox.svg" alt="" srcset="">
              <p class="center">暂无数据</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pagination v-if="list.tableData.length" :pageNum="list.pageNum" :pageSize="list.pageSize" :total="list.total" @sizeChange="handleSizeChange" @currentChange="handleCurrentChange"
      :key="list.pageNum" />
    <unlock-dialog :show.sync="unlockDialogShow" :list="companyList" :usedTotalDialogP="usedTotalDialog" title="批量解锁" :confirmPromise="contactsNumBatchConfirm"></unlock-dialog>

    <!-- 批量解锁提示 -->
    <batch-unlock-tip ref="batchUnlockTip"></batch-unlock-tip>
  </div>

</template>

<script>
import pagination from '@/components/pagination/'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import companyList from '@/views/inquiry/components/companyList'
import { contactExport, batchStar, contactsNumBatchV2, deepKeyword, unlockContacts } from '../api/newClueApi'
import companyCard from './companyCard'
import unlockDialog from './unlockDialog'
import { cueQuotaStatistics } from '@/views/home/api'
import batchUnlockTip from '@/components/batchUnlockTip'

export default {
  name: 'companyCardList',
  components: {
    companyCard,
    pagination,
    unlockDialog,
    companyList,
    batchUnlockTip
  },
  props: {
    batchActions: {
      type: Array,
      default: () => [true, true, false] // 0.解锁  1.收藏  2.导出
    },
    searchType: {
      type: Number | String,
      default: 0 // 0-智能搜索  1-企业名称  2-经营范围  3-产品  4-法人/高管 5-专利  6-地址 7-网络推广
    },
    list: {
      type: Object,
      default() {
        return {
          pageNum: 1,
          pageSize: 20,
          total: 0,
          tab: 1,
          tableData: []
        }
      }
    },
    shortVideoType: {
      type: String,
      default: () => ''
    },
    inquiryData: {
      type: Object,
      default: () => {
        return {
          nickName: '卖女孩的小火柴',
          source: 'douyin',
          constellation: '天蝎座',
          uniqueId: 'bug高级工程师',
          createTime: '2022-03-14',
          awemeCount: '20',
          signature: '天不生我李淳罡，剑道万古如长夜',
          comDesc: '空压机#生产厂家#工厂实拍',
          keyWord: '上海机械',
          videoUrl: 'https://api-hl.amemv.com/aweme/v1/play/?video_id=v0200fg10000c3p9gtbc77u844at3ur0&line=1&file_id=6721cafb05c04379ade12ce4f8a3a7a5&sign=cb25dbd96afc3b2172f5354021623248&is_play_url=1&source=PackSourceEnum_SEARCH',
          text: '变频器哪个厂家的，怎么卖'
        }
      }
    },
    companyType: { // 埋点  解锁来源1 企业搜索 2 新企搜索 3 招标搜索  4 高级搜索  5 商机地图  6 智能推荐 7 匿名获客 8.批量解锁 9.我的收藏 10 订阅企业 11 园区获客详情
      type: Number
    },
    subscriptionType: {
      type: Number
    },
    resetUnlockS: {
      type: Boolean,
      default: false
    },
    // batchActionShow 已经失去意义。代码混乱，临时添加一个按钮控制..
    batchStarShow: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      numKey: null,
      actionLoading: false,
      actionLoading1: false,
      exportAllLoading: false,
      showSetCheckBox: [true, false, false], // 0.批量解锁  1.批量收藏  2.批量导出
      checkList: [],
      drawerKey: 0,
      numberData: [],
      companyStatus: { companyName: '', tag: '' },
      watchOnce: false,
      unlockDialogShow: false,
      companyList: [],

      // 深度挖掘相关
      deepLoading: false,
      usedTotalDialog: 0,
      isIndeterminate: false,
      checkAll: false,
      selectNum: 0,//动态选中个数
      isUnlock: false,
    }
  },
  computed: {
    ...mapState({
      deepTaskList: state => state.user.deepTaskList,
      clickCompanyArr: state => state.user.clickCompanyArr
    }),
    ...mapGetters(['deepingTaskCount']),

    batchActionShow() {
      return this.batchActions.some(v => v)
    },
    checkBoxShow() {
      return this.showSetCheckBox.some(v => v)
    },
    selectAll() {
      const arr = this.checkList.filter(e => e.checked === false)
      if (arr.length == 0) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
      return arr.length
    },
    isEnterpriseName() {
      return this.$route.path == '/zxk/search/clueList' && (this.searchType == 1 || this.searchType == 0)
    }
  },
  watch: {
    list: {
      deep: true,
      handler(val) {
        this.cancalAllFn()
        this.getClickCompany()
      }
    },
    batchActions: {
      deep: true,
      handler: function (val) {
        if (!val[0]) {
          this.cancalAllFn()
        }
      }
    },
    resetUnlockS: {
      deep: true,
      handler: function (val) {
        this.isUnlock = val
      }
    }
  },
  mounted() {
    this.getClickCompany()
  },
  methods: {
    resetUnlock(val) {
      this.isUnlock = val
    },
    // 过滤解锁
    isUnlockChange() {
      this.$emit('isUnlock-Change', this.isUnlock)
    },
    getClickCompany() {
      if(this.clickCompanyArr.length){
        this.list.tableData.map(e => {
          if (this.clickCompanyArr.includes(e.hid)) {
            e.isClick = true
          } 
        })
      }
    },
    clickListA(val) {
      if (!this.clickCompanyArr.includes(val.hid)) {
        this.clickCompanyArr.push(val.hid)
        localStorage.setItem("clickList", JSON.stringify(this.clickCompanyArr), 1)
      }
    },
    getStar(index) {
      this.numKey = Math.random()
      this.list.tableData[index].star = !this.list.tableData[index].star
      this.$emit('getData')
    },
    // 点击深度挖掘
    clickDeepAction() {
      // 1.判断现在的任务和进行中的任务是否冲突
      const { word } = this.$route.query || {}
      const hasDeeping = this.deepTaskList.some(v => v.status == 1 && v.keyword == word.trim())
      if (hasDeeping) {
        this.$message.warning('有相同挖掘进行中，请勿重复提交')
        return
      }
      // 2.判断现在的任务数是不是超过5个
      if (this.deepingTaskCount >= 5) {
        this.$message.warning('小T体力有限，挖掘有5个进行中，请稍后再试!')
        return
      }
      this.reqDeepKeyword(word.trim())
    },
    reqDeepKeyword(word) {
      this.deepLoading = true
      deepKeyword({ keyword: word }).then(({ code, message }) => {
        if (code != 200) {
          this.$message.error(message)
          return
        }
        this.$store.dispatch('REQ_DEEP_TASK_LIST')
        this.$message.success('小T正在努力帮您挖掘')
      }).catch((err) => {
        if (err == 'error') this.$message.error('小T非常抱歉提醒您: 挖掘失败,请重新尝试')
      }).finally(() => this.deepLoading = false)
    },
    companyNames() {
      return this.checkList.filter(e => (e.checked && !e.star)).map(e => {
        // type 1 标准资源
        return { name: this.removeHtml(e.companyName), hid: e.hid, type: 1, similarValue: e.similarValue || null, similarity: e.similarity || null }
      })
    },
    handleUnlockChange(index) {
      if (this.checkBoxShow) {
        this.checkList[index].checked = true
      }
    },
    clickExportAll() {
      this.exportAllLoading = true
      contactExport({
        type: 0
      }).then(res => {
        const link = document.createElement('a')
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', '全部联系方式' + '.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }).finally(() => {
        this.exportAllLoading = false
      })
    },
    batchExportFn() {
      this.actionLoading = true
      contactExport({
        list: this.checkList.filter(e => e.checked).map(e => this.removeHtml(e.companyName)),
        type: 1
      }).then(res => {
        const link = document.createElement('a')
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', '批量联系方式' + '.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.checkList.filter(e => e.checked).forEach(e => e.checked = false)
      }).finally(() => {
        this.actionLoading = false
      })
    },
    handleSizeChange(val) {
      console.log('lll')
      this.cancalAllFn()
      this.$emit('handle-page-num', val)
    },
    handleCurrentChange(val) {
      this.cancalAllFn()
      this.$emit('handle-page', val)
    },
    showCheckBox(type) {
      if (type || type === 0) {
        this.showSetCheckBox[type] = !this.showSetCheckBox[type]
        const arr = [false, false, false]
        arr[type] = this.showSetCheckBox[type]
        this.showSetCheckBox = arr
      } else {
        this.showSetCheckBox = [false, false, false]
      }
      this.checkList.length = 0
      this.list.tableData.forEach(e => {
        this.checkList.push({ companyName: e.name || e.companyName, hid: e.hid, checked: false, star: e.star, unlock: e.unlock, similarValue: e.similarValue || null, similarity: e.similarity || null, id: e.id || null, isCollect: e.isCollect || null, keyWord: e.keyWord || null, videoUrl: e.videoUrl || null, videoDes: e.comDesc || null, isUnlock: e.isUnlock || null })
      })
    },
    selectSingleFnG(val) {
      this.selectNum = this.checkList.filter(e => (e.checked)).length
      if (this.selectNum == this.checkList.length) {
        this.checkAll = true
        this.isIndeterminate = false
      } else {
        this.checkAll = false
        if (0 < this.selectNum < this.list.pageSize) {
          this.isIndeterminate = true
        }
        if (this.selectNum == 0) {
          this.isIndeterminate = false
        }
      }

    },
    selectAllFnG(val) {
      if (val) {
        this.checkList.forEach(e => { e.checked = true })
        this.selectNum = this.checkList.length
        this.isIndeterminate = false
      } else {
        this.selectNum = 0
        this.checkList = []
        if (this.list.tableData) {
          this.list.tableData.forEach(e => {
            this.checkList.push({ companyName: e.name || e.companyName, hid: e.hid, checked: false, star: e.star, unlock: e.unlock, similarValue: e.similarValue || null, similarity: e.similarity || null, id: e.id || null, isCollect: e.isCollect || null, keyWord: e.keyWord || null, videoUrl: e.videoUrl || null, videoDes: e.comDesc || null, isUnlock: e.isUnlock || null })
          })
        }
      }
    },
    selectAllFn() {
      this.checkList.forEach(e => { e.checked = true })
    },
    cancalAllFn() {
      this.isIndeterminate = false
      this.selectNum = 0
      this.checkAll = false
      this.checkList = []
      this.list.tableData.forEach(e => {
        this.checkList.push({ companyName: e.name || e.companyName, hid: e.hid, checked: false, star: e.star, unlock: e.unlock, similarValue: e.similarValue || null, similarity: e.similarity || null, id: e.id || null, isCollect: e.isCollect || null, keyWord: e.keyWord || null, videoUrl: e.videoUrl || null, videoDes: e.comDesc || null, isUnlock: e.isUnlock || null })
      })
    },
    removeHtml(str) {
      if (!str) return
      const reTag = /<(?:.|\s)*?>/g
      return str.replace(reTag, '').replace(/&nbsp;/ig, '')
    },
    async batchStar(companyList) {
      if (companyList.length) {
        try {
          this.actionLoading1 = true
          await batchStar({ companyList })
          this.actionLoading1 = false
          this.$message.success('收藏成功')
          this.$emit('getData')
          this.list.tableData.forEach(e => {
            if (companyList.find(ee => (ee.name || ee.companyName) === this.removeHtml(e.name || e.companyName))) {
              e.star = true
            }
          })
          this.checkList.filter(e => e.checked).forEach(e => e.checked = false)
        } catch (error) {
          this.actionLoading1 = false
        }
      } else {
        this.$message.warning('已经收藏过了')
      }
    },
    getcueQuotaStatistics() {
      cueQuotaStatistics().then(res => {
        if (res.code == 200) {
          this.usedTotalDialog = res.data.companyInterest.usedTotal
        }
      })
    },
    contactsNumBatchV2(companyList) {
      if (companyList.length) {
        // 重新获取解锁数据
        // this.$store.commit('SET_FREQUENCY', this.$store.state.user.frequency + 1)
        this.getcueQuotaStatistics()
        this.unlockDialogShow = true
        this.companyList = companyList
      } else {
        this.$message.warning('已经解锁过了')
      }
    },
    contactsNumBatchConfirm() {
      return new Promise((resolve, reject) => {
        this.actionLoading = true
        let list = this.companyList.map(v => ({ ...v, source: this.companyType }))
        contactsNumBatchV2({ list }).then(res => {
          this.actionLoading = false
          const { code, data = [], message } = res
          console.dir(res)
          if (code == 200) {
            resolve()
            this.$message.success('解锁成功')
            // let succeededHidsArr = []
            // unlockContacts({hids:data[0].succeededHids}).then(rs =>{
            //         if(rs.code == 200){
            //            succeededHidsArr = rs.data
            //         }
            // })

            unlockContacts({ hids: data[0].succeededHids }).then(rs => {
              if (rs.code == 200) {
                this.list.tableData.forEach(e => {
                  const name = this.removeHtml(e.name || e.companyName)
                  // if (this.companyList.find(ee => (ee.name || ee.companyName) === name) && data.indexOf(name) != -1) {
                  if (this.companyList.find(ee => (ee.name || ee.companyName) === name) && data[0].succeededHids.indexOf(e.hid) != -1) {  // data 返回的是hid数组
                    e.unlock = true
                    e.contactListVOS = rs.data[e.hid]
                  }
                })

                this.checkList.filter(e => e.checked).forEach(e => e.checked = false)
                this.selectNum = 0
              }
            })

          } else {
            reject()
            this.$message.error(message)
          }
        }).catch((error) => {
          console.dir(error)
          reject()
          this.actionLoading = false
        })
      })
    },

    batchUnlockFn() {
      if (this.shortVideoType !== '1') {
        if (this.checkList.filter(e => e.checked).length) {
          this.contactsNumBatchV2(this.checkList.filter(e => (e.checked && !e.unlock)).map(e => {
            const obj = { companyName: this.removeHtml(e.companyName), hid: e.hid }
            if (e.similarValue) obj.similarValue = e.similarValue
            if (e.similarity) obj.similarity = e.similarity
            return obj
          }))
        } else {
          this.$message.warning('还未选择企业')
        }
      } else {
        if (this.checkList.filter(e => e.checked).length) {
          this.$emit('unlockUser', this.checkList)
        } else {
          this.$message.warning('还未选择用户')
        }
      }
    },
    batchStarFn() {
      if (this.shortVideoType !== '1') {
        if (this.checkList.filter(e => e.checked).length) {
          this.batchStar(this.companyNames())
        } else {
          this.$message.warning('还未选择企业')
        }
      } else {
        if (this.checkList.filter(e => e.checked).length) {
          this.$emit('batchCollect', this.checkList)
        } else {
          this.$message.warning('还未选择用户')
        }
      }
    },

    handleCollect(val) {
      this.$emit('handleCollect', val)
    },

    unHandleCollect(val) {
      this.$emit('unHandleCollect', val)
    },

    immediatelyUnlock(obj) {
      this.$emit('immediatelyUnlock', obj)
    },

    checkDetails(obj) {
      this.$emit('checkDetails', obj)
    }
  }
}
</script>
<style lang="scss" scoped>
.searchContent {
  // padding-bottom: 24px;
  // padding-bottom: 8px;
  background-color: #fff;
  margin-bottom: 24px;
  box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
  border-radius: 4px 4px 0px 0px;
  .cardTitle {
    background: #ffffff;
    border-radius: 4px 4px 0px 0px;
    padding: 0 15px;
    overflow: hidden;
    display: flex;
    > span {
      color: #d9001b;
    }
    .slot {
      // flex-grow: 1;
      // flex-shrink: 1;
    }
    .btnBlock {
      display: flex;
      align-items: center;
      // margin-left: 20px;
      margin-right: 24px;
      /deep/ .el-button {
        > span {
          font-size: 12px;
        }
      }
    }
  }
  .setCheckBox {
    text-align: center;
    height: 72px;
    // background-color: #f3f9ff;
    background: rgba(187, 190, 202, 0.3);
    line-height: 72px;
    /deep/ .el-button {
      padding: 0;
      width: 100px;
      height: 32px;
      border-radius: 4px;
      // margin-left: 30px;
      > span {
        font-size: 14px;
      }
      &:nth-of-type(1) {
        margin-left: 0;
        color: #333333;
        background: rgba(255, 255, 255, 0.2);
        box-shadow: 0px 2px 4px 0px #edeef3;
        border-radius: 4px;
        border: 1px solid #bbbeca;
      }
    }
  }
  .checkBoxes {
    position: relative;
    // width: 33px;
    margin-right: 50px;
  }
  .companyCardList {
    .emptyBox {
      text-align: center;
      padding: 100px;
      .emptyBox-box {
        display: flex;
        justify-content: center;
        .empty-deep {
          text-align: left;
          margin-left: 30px;
          p {
            margin-bottom: 10px;
          }
          p:first-child {
            font-weight: 600;
            color: #000;
          }
        }
        .empty-ordinary {
          img {
            width: 150px;
            margin-bottom: -20px;
          }
          p {
            color: #999999;
          }
        }
      }
    }
    // .deep-btn {
    //   display: block;
    //   color: #fff;
    //   background: #4f7afd;
    //   padding: 5px 30px;
    //   border-radius: 4px;
    //   width: 200px;
    //   margin: 15px auto;
    //   cursor: pointer;
    // }
  }
}
.schMd {
  .cardTitle {
    border-radius: 4px 4px 0px 0px;
    padding: 0;
    .insideBox {
      display: flex;
      // justify-content: space-between;
      align-items: center;
      padding: 0 24px;
      box-sizing: border-box;
      width: 100%;
      height: 64px;
      //  line-height: 64px;
      border-radius: 4px 4px 0px 0px;
    }
  }
  .insideBox {
    // .slot{
    //   width: 60%;
    //   float: left;
    // }
    .btnBlock {
      .el-button {
        margin-left: 24px;
      }
    }
  }
  &.cardlist {
    .cardTitle {
      padding: 0px 0 0;
      margin-top: 16px;
    }
  }
}

.pagination {
  padding-top: 24px;
}

.searchContent {
  .setCheckBox.gbBatchUnlock {
    background: none;
    height: auto;
    line-height: normal;
    margin-left: 8px;
    padding-left: 8px;
    position: relative;
    &::before {
      position: absolute;
      content: "";
      display: block;
      width: 1px;
      height: 18px;
      background: #efefef;
      top: 0;
      bottom: 0;
      left: 0;
      margin: auto;
    }
    .el-button {
      color: #333333;
      background: rgba(255, 255, 255, 0.2);
      box-shadow: 0px 2px 4px 0px #edeef3;
      border-radius: 4px;
      border: 1px solid #bbbeca;
      margin-left: 8px;
    }
    .choiceNum {
      margin-right: 38px;
      font-weight: 600;
      color: rgba(52, 57, 81, 0.7);
      font-size: 16px;
    }
  }
}
.companyHead {
  display: flex;
  height: 52px;
  line-height: 52px;
  background: #f5f6f8;
  padding: 0 0px 0 32px;
  box-sizing: border-box;
  justify-content: space-between;
  .compHDLeft {
    //  width: 81%;
  }
  span {
    font-weight: 600;
    color: #343951;
    font-size: 14px;
    display: inline-block;
    &.headInfo {
      // width: 61%;
    }
    &.headMay {
      width: 20.09%;
      box-sizing: border-box;
    }
    &.mapHead {
      width: 24.09%;
    }
  }
}

::v-deep {
  .btnBlock {
    .el-button {
      i {
        margin-right: 4px;
        display: inline-block;
        &::before {
          content: "";
          width: 20px;
          height: 20px;
          display: inline-block;
          vertical-align: -5px;
        }
      }
    }
    .icon-shoucang1xiao {
      &::before {
        background-image: url("~@/assets/gbIcon/xx.svg");
      }
    }
    .icon-jiesuo {
      &::before {
        background-image: url("~@/assets/gbIcon/unlocking.svg");
      }
    }
    .filter-unlock {
      margin-right: 0;
      line-height: 38px;
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: rgb(80, 136, 255);
      }
    }
    .el-checkbox {
      line-height: 20px;
      color: rgb(92, 96, 117);
    }
  }
}
@media screen and(max-width:1550px) {
  .companyHead {
    span {
      &.headMay {
        width: 24.09%;
      }
    }
  }
}
</style>
<style lang="scss">
.gbInsideBox {
  .searchBar {
    line-height: 36px;
  }
}
</style>
